import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/userContext';
import { getLucky6Access } from 'services/api/lucky6Service';

// One request per logged-in player per page load; every menu that shows the
// Lucky Six entry shares it.
let cached: { userId: number; enabled: Promise<boolean> } | null = null;

export function useLucky6Access(): boolean {
  const { loggedUser } = useContext(UserContext);
  const userId: number | undefined = loggedUser?.id;
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!userId) {
      setEnabled(false);
      return;
    }
    if (!cached || cached.userId !== userId) {
      cached = { userId, enabled: getLucky6Access().catch(() => false) };
    }
    let live = true;
    cached.enabled.then((v) => live && setEnabled(v));
    return () => {
      live = false;
    };
  }, [userId]);
  return enabled;
}
